// @flow

// Determine if element is in the viewport (vertically)
const isElementInViewport = (element: ?HTMLElement): boolean => {
  if (element && document && document.documentElement && window) {
    const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

    return element.getBoundingClientRect().top < viewportHeight;
  }

  return false;
};

export default isElementInViewport;
